<div class="grid grid-cols-9 gap-4">
    <ng-container *ngFor="let size of sizes">
        <ng-container *ngFor="let shape of shapes; let i = index">

            <avatar [shape]="shape" [size]="size" [status]="statuses[i % statuses.length]">
            </avatar>

            <avatar [shape]="shape" [size]="size" [status]="statuses[i % statuses.length]" [userName]="userName">
            </avatar>

            <avatar [shape]="shape" [size]="size" [status]="statuses[i % statuses.length]" [imageUrl]="imageUrl">
            </avatar>

        </ng-container>
    </ng-container>
</div>